module.exports = __webpack_public_path__ + "static/media/Share.13a0a838.svg";